import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Button from './Button'

class InputGroup extends Component {
  constructor () {
    super()
    this.state = {
      inputValue: ''
    }
    this._handleInputChange = this._handleInputChange.bind(this)
  }
  _handleInputChange (e) {
    const newVal = e.target.value
    this.setState({
      inputValue: newVal
    })
    if (this.props.inputOnChange) {
      this.props.inputOnChange(e, newVal)
    }
  }
  render () {
    const {
      inputType,
      inputRefFn,
      placeholder,
      autoComplete,
      autoFocus,
      // button
      buttonType,
      buttonLabel,
      buttonOnClick,
      extraClass
    } = this.props
    const { inputValue } = this.state
    return (
      <div className={classnames('input-group', extraClass)}>
        <input
          ref={inputRefFn}
          value={inputValue}
          onChange={this._handleInputChange}
          className='input-group__input flex-auto'
          type={inputType}
          placeholder={placeholder}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
        />
        <Button
          className='input-group__button button flex-none'
          type={buttonType}
          onClick={buttonOnClick && (e => buttonOnClick(e, inputValue))}
        >
          {buttonLabel}
        </Button>
      </div>
    )
  }
}

InputGroup.propTypes = {
  inputRefFn: PropTypes.func,
  inputType: PropTypes.string,
  inputOnChange: PropTypes.func,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.bool,
  autoFocus: PropTypes.bool,
  buttonType: PropTypes.string,
  buttonLabel: PropTypes.string.isRequired,
  buttonOnClick: PropTypes.func,
  extraClass: PropTypes.string
}

InputGroup.defaultProps = {
  buttonLabel: 'Send',
  clickButtonOnEnter: true
}

export default InputGroup



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/InputGroup.js